const actions = {
  AI_RECORDER_OPEN_MODAL: 'AI_RECORDER_OPEN_MODAL',
  AI_RECORDER_CLOSE_MODAL: 'AI_RECORDER_CLOSE_MODAL',
  AI_RECORDER_MINIMIZE_MODAL: 'AI_RECORDER_MINIMIZE_MODAL',
  AI_RECORDER_EXPAND_MODAL: 'AI_RECORDER_EXPAND_MODAL',
  AI_RECORDER_START_RECORDING: 'AI_RECORDER_START_RECORDING',
  AI_RECORDER_START_RECORDING_SUCCESS: 'AI_RECORDER_START_RECORDING_SUCCESS',
  AI_RECORDER_START_RECORDING_FAILURE: 'AI_RECORDER_START_RECORDING_FAILURE',
  AI_RECORDER_PAUSE_RECORDING: 'AI_RECORDER_PAUSE_RECORDING',
  AI_RECORDER_PAUSE_RECORDING_SUCCESS: 'AI_RECORDER_PAUSE_RECORDING_SUCCESS',
  AI_RECORDER_RESUME_RECORDING: 'AI_RECORDER_RESUME_RECORDING',
  AI_RECORDER_RESUME_RECORDING_SUCCESS: 'AI_RECORDER_RESUME_RECORDING_SUCCESS',
  AI_RECORDER_STOP_RECORDING: 'AI_RECORDER_STOP_RECORDING',
  AI_RECORDER_STOP_RECORDING_SUCCESS: 'AI_RECORDER_STOP_RECORDING_SUCCESS',
  AI_RECORDER_DELETE_RECORDING: 'AI_RECORDER_DELETE_RECORDING',
  AI_RECORDER_DELETE_RECORDING_SUCCESS: 'AI_RECORDER_DELETE_RECORDING_SUCCESS',
  AI_RECORDER_FINALIZE_RECORDING: 'AI_RECORDER_FINALIZE_RECORDING',
  AI_RECORDER_FINALIZE_RECORDING_SUCCESS: 'AI_RECORDER_FINALIZE_RECORDING_SUCCESS',
  AI_RECORDER_FETCH_MICROPHONES: 'AI_RECORDER_FETCH_MICROPHONES',
  AI_RECORDER_FETCH_MICROPHONES_SUCCESS: 'AI_RECORDER_FETCH_MICROPHONES_SUCCESS',
  AI_RECORDER_FETCH_MICROPHONES_FAILURE: 'AI_RECORDER_FETCH_MICROPHONES_FAILURE',
  AI_RECORDER_CHANGE_MICROPHONE: 'AI_RECORDER_CHANGE_MICROPHONE',
  AI_RECORDER_CHANGE_MICROPHONE_SUCCESS: 'AI_RECORDER_CHANGE_MICROPHONE_SUCCESS',
  AI_RECORDER_CHANGE_MICROPHONE_FAILURE: 'AI_RECORDER_CHANGE_MICROPHONE_FAILURE',
  AI_RECORDER_LOAD_WIDGET_POSITION: 'AI_RECORDER_LOAD_WIDGET_POSITION',
  AI_RECORDER_CHANGE_WIDGET_POSITION: 'AI_RECORDER_CHANGE_WIDGET_POSITION',
  AI_RECORDER_CHANGE_WIDGET_POSITION_SUCCESS: 'AI_RECORDER_CHANGE_WIDGET_POSITION_SUCCESS',
  AI_RECORDER_PROCESS_AUDIO: 'AI_RECORDER_PROCESS_AUDIO',
  AI_RECORDER_PROCESS_AUDIO_SUCCESS: 'AI_RECORDER_PROCESS_AUDIO_SUCCESS',
  AI_RECORDER_PROCESS_AUDIO_FAILURE: 'AI_RECORDER_PROCESS_AUDIO_FAILURE',
  AI_RECORDER_UPDATE_RECORDING_TIME: 'AI_RECORDER_UPDATE_RECORDING_TIME',
  AI_RECORDER_UPDATE_AUDIO_LEVEL: 'AI_RECORDER_UPDATE_AUDIO_LEVEL',
  AI_RECORDER_SET_TIME_WARNING: 'AI_RECORDER_SET_TIME_WARNING',
  AI_RECORDER_TIME_LIMIT_REACHED: 'AI_RECORDER_TIME_LIMIT_REACHED',
  AI_RECORDER_SET_ERROR: 'AI_RECORDER_SET_ERROR',
  AI_RECORDER_CLEAR_ERROR: 'AI_RECORDER_CLEAR_ERROR',
  AI_RECORDER_RESET_RECORDER: 'AI_RECORDER_RESET_RECORDER',
  AI_RECORDER_ADD_AUDIO_CHUNK: 'AI_RECORDER_ADD_AUDIO_CHUNK',
  AI_RECORDER_CLEAR_AUDIO_CHUNKS: 'AI_RECORDER_CLEAR_AUDIO_CHUNKS',
  AI_RECORDER_SET_SELECTED_ID: 'AI_RECORDER_SET_SELECTED_ID',
  AI_RECORDER_UPDATE_TRANSCRIPTION: 'AI_RECORDER_UPDATE_TRANSCRIPTION',
  AI_RECORDER_REGENERATE_REPORT: 'AI_RECORDER_REGENERATE_REPORT',
  AI_RECORDER_UPDATE_REPORT: 'AI_RECORDER_UPDATE_REPORT',
  AI_RECORDER_SHOW_HELP_MODAL: 'AI_RECORDER_SHOW_HELP_MODAL',
  AI_RECORDER_SHOW_HELP_MODAL_CLOSE: 'AI_RECORDER_SHOW_HELP_MODAL_CLOSE',
  AI_RECORDER_DONT_SHOW_HELP_AGAIN: 'AI_RECORDER_DONT_SHOW_HELP_AGAIN',
  AI_RECORDER_SET_PROCESSING_STEP: 'AI_RECORDER_SET_PROCESSING_STEP',
  AI_RECORDER_OPEN_TEST_MODAL: 'AI_RECORDER_OPEN_TEST_MODAL',
  AI_RECORDER_CLOSE_TEST_MODAL: 'AI_RECORDER_CLOSE_TEST_MODAL',
  AI_RECORDER_GET_PERMISSION_SUCCESS: 'AI_RECORDER_GET_PERMISSION_SUCCESS',
  AI_RECORDER_RETRY_PROCESS_AUDIO: 'AI_RECORDER_RETRY_PROCESS_AUDIO',
  AI_RECORDER_RETRANSCRIBE_AUDIO: 'AI_RECORDER_RETRANSCRIBE_AUDIO',

  openModal: () => ({ type: actions.AI_RECORDER_OPEN_MODAL }),
  closeModal: () => ({ type: actions.AI_RECORDER_CLOSE_MODAL }),
  minimizeModal: () => ({ type: actions.AI_RECORDER_MINIMIZE_MODAL }),
  expandModal: () => ({ type: actions.AI_RECORDER_EXPAND_MODAL }),
  startRecording: (microphoneId) => ({
    type: actions.AI_RECORDER_START_RECORDING,
    payload: { microphoneId },
  }),
  pauseRecording: () => ({ type: actions.AI_RECORDER_PAUSE_RECORDING }),
  resumeRecording: () => ({ type: actions.AI_RECORDER_RESUME_RECORDING }),
  stopRecording: () => ({ type: actions.AI_RECORDER_STOP_RECORDING }),
  deleteRecording: () => ({ type: actions.AI_RECORDER_DELETE_RECORDING }),
  finalizeRecording: () => ({ type: actions.AI_RECORDER_FINALIZE_RECORDING }),
  fetchMicrophones: () => ({ type: actions.AI_RECORDER_FETCH_MICROPHONES }),
  changeMicrophone: (microphoneId) => ({
    type: actions.AI_RECORDER_CHANGE_MICROPHONE,
    payload: { microphoneId },
  }),
  loadWidgetPosition: () => ({ type: actions.AI_RECORDER_LOAD_WIDGET_POSITION }),
  changeWidgetPosition: (position) => ({
    type: actions.AI_RECORDER_CHANGE_WIDGET_POSITION,
    payload: { position },
  }),
  processAudio: (audioBlob, useAlternativeTranscription = false) => ({
    type: actions.AI_RECORDER_PROCESS_AUDIO,
    payload: { audioBlob, useAlternativeTranscription },
  }),
  updateRecordingTime: (time) => ({
    type: actions.AI_RECORDER_UPDATE_RECORDING_TIME,
    payload: { time },
  }),
  updateAudioLevel: (level) => ({
    type: actions.AI_RECORDER_UPDATE_AUDIO_LEVEL,
    payload: { level },
  }),
  setError: (error) => ({
    type: actions.AI_RECORDER_SET_ERROR,
    payload: { error },
  }),
  clearError: () => ({ type: actions.AI_RECORDER_CLEAR_ERROR }),
  resetRecorder: () => ({ type: actions.AI_RECORDER_RESET_RECORDER }),
  addAudioChunk: (chunk) => ({
    type: actions.AI_RECORDER_ADD_AUDIO_CHUNK,
    payload: { chunk },
  }),
  clearAudioChunks: () => ({
    type: actions.AI_RECORDER_CLEAR_AUDIO_CHUNKS,
  }),
  setSelectedId: (selectedId, recordFieldMode) => ({
    type: actions.AI_RECORDER_SET_SELECTED_ID,
    payload: { selectedId, recordFieldMode },
  }),
  updateTranscription: (transcription) => ({
    type: actions.AI_RECORDER_UPDATE_TRANSCRIPTION,
    payload: { transcription },
  }),
  regenerateReport: (transcription) => ({
    type: actions.AI_RECORDER_REGENERATE_REPORT,
    payload: { transcription },
  }),
  updateReport: (report) => ({
    type: actions.AI_RECORDER_UPDATE_REPORT,
    payload: { report },
  }),
  showHelpModal: () => ({ type: actions.AI_RECORDER_SHOW_HELP_MODAL }),
  closeHelpModal: () => ({ type: actions.AI_RECORDER_SHOW_HELP_MODAL_CLOSE }),
  dontShowHelpAgain: () => ({ type: actions.AI_RECORDER_DONT_SHOW_HELP_AGAIN }),
  setProcessingStep: (progress) => ({
    type: actions.AI_RECORDER_SET_PROCESSING_STEP,
    payload: { progress },
  }),
  openTestModal: () => ({ type: actions.AI_RECORDER_OPEN_TEST_MODAL }),
  closeTestModal: () => ({ type: actions.AI_RECORDER_CLOSE_TEST_MODAL }),
  retryProcessAudio: () => ({ type: actions.AI_RECORDER_RETRY_PROCESS_AUDIO }),
  retranscribeAudio: () => ({ type: actions.AI_RECORDER_RETRANSCRIBE_AUDIO }),
};

export default actions;
